export default {
  headerContent: {
    title: 'Hdi Sigorta Kasko Sigortası Teklifi Hesaplama',
    slogan: "Araç Kasko Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'ARAÇ KASKO SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'HDI Sigorta Araç Kasko Sigortası',
    description: {
      title: 'HDI Sigorta Araç Kasko Sigortası Nedir? ',
      content: [
        'Kasko sigortası, aracınızda oluşacak hasarlar sonucu doğan maddi kayıplara karşı güvence sağlamaktadır.',
        'Kapsamlı bir kasko poliçesi, birçok farklı riski kapsayabilir ve sizi finansal olarak koruyabilir. Araba sigortasının rolü, meydana gelen kaza ve hasar durumlarına karşı aracınızı korurken bütçenizi de korumaktır.',
        'HDI Kasko Sigortası sizi potansiyel olarak yıkıcı mali sorumluluklara karşı güvence altına alır!'
      ]
    },
    subContent: {
      title: 'Hdi Sigorta Araç Kasko Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph: 'Hdi Sigorta kasko poliçesi ile sunulan teminatlar;',
          subList: [
            'Çarpma ve çarpışma teminatı,',
            'Devrilme teminatı,',
            'Yangın teminatı,',
            'Sigara ve benzeri maddelerin teması sonucu oluşan yangın dışındaki zararlar,',
            'Hırsızlık teminatı,',
            'Cam kırılması teminatı,',
            'Doğal afetler teminatı,',
            'Hayvanların araca vereceği zararlar,',
            'Grev, lokavt, halk hareketleri, kargaşalık, kötü niyetli hareketler ve terör kaynaklı oluşabilecek zararları kapsar.'
          ]
        },
        {
          paragraph:
            '**Sigorta şirketinin sunmuş olduğu kasko ürünleri arasında yer alan paketlerin içerdiği teminatlar değişiklik göstermektedir. Paket bazında sigorta kapsamının değişmesi ile kasko fiyatları da değişiklik gösterecektir. Bu sebeple teminatları ihtiyaçlarınıza göre değerlendirmeli ve en uygun paketi seçmelisiniz. ',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Araç Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Araç Kasko Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Araç Kasko Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Araç Kasko Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Araç Kasko Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'HDI Sigorta Araç Kasko Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
